import { render, staticRenderFns } from "./IBpmn.vue?vue&type=template&id=f2032cb0&scoped=true&"
import script from "./IBpmn.vue?vue&type=script&lang=js&"
export * from "./IBpmn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2032cb0",
  null
  
)

export default component.exports